import {useCallback, useEffect} from 'react'
import {useTracking} from '../../../Tracking/Tracking.hooks'
import FullscreenIcon from './full_screen.svg'
import clsx from 'clsx'

export const FullscreenButton = ({isGrillQuizSettings}: {isGrillQuizSettings: boolean}) => {
  const {trackEvent} = useTracking()

  const toggleFullScreen = useCallback(() => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen()

      trackEvent({
        domain: `settings`,
        trigger: 'click',
        source: 'fullscreen_enter_button',
      })
    } else if (document.exitFullscreen) {
      document.exitFullscreen()

      trackEvent({
        domain: `settings`,
        trigger: 'click',
        source: 'fullscreen_exit_button',
      })
    }
  }, [])

  const keyListener = useCallback((e: KeyboardEvent) => {
    if (e.ctrlKey && e.key === 'f') {
      toggleFullScreen()
    }
  }, [])

  useEffect(() => {
    document.addEventListener('keydown', keyListener, false)

    return () => {
      document.removeEventListener('keydown', keyListener, false)
    }
  }, [])

  return (
    <button
      id="full-screen-btn"
      className={clsx(
        'settings-button pointer-events-auto hidden lg:flex',
        isGrillQuizSettings && 'grill-quiz-settings-button',
      )}
      onClick={toggleFullScreen}
    >
      <img src={FullscreenIcon} alt="" />
    </button>
  )
}
